module.exports = __webpack_public_path__ + "img/1F642.56108866.svg";